import { useQuery as useApolloQuery } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedUseQuery } from '@/lib/apollo/types'

import type { QueryVars, Response } from './query'
import getExecutive from './query'

export const useQuery: WrappedUseQuery<Response, QueryVars> = (options = {}) =>
  useApolloQuery<Response, QueryVars>(getExecutive, {
    client: agentClient,
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    ...options,
  })
